import type { WorkflowDefinition } from '../../api/workflowRuns'
import { workflowShelfGridClass } from '../../lib/workflowShelfGrid'
import { ThemeStagger, ThemeStaggerItem } from '../motion/ThemeMotion'
import { WorkflowDefinitionCard } from './WorkflowDefinitionCard'

type Props = {
  definitions: WorkflowDefinition[]
  angular: boolean
  layoutReflow?: boolean
  runningDefinitionId?: string | null
  onRun?: (definition: WorkflowDefinition) => void
}

/** 工作流书架：响应式 auto-fill 栅格，一格一条编排。 */
export function WorkflowShelf({ definitions, angular, layoutReflow = true, runningDefinitionId, onRun }: Props) {
  return (
    <ThemeStagger className={workflowShelfGridClass} aria-label="我的工作流">
      {definitions.map((definition) => (
        <ThemeStaggerItem key={definition.publicId} className="min-w-0" layoutReflow={layoutReflow}>
          <WorkflowDefinitionCard
            definition={definition}
            angular={angular}
            running={runningDefinitionId === definition.publicId}
            onRun={onRun}
          />
        </ThemeStaggerItem>
      ))}
    </ThemeStagger>
  )
}
